import { useQuery } from "@tanstack/react-query";
import type { Message } from "@school-sales-ai/shared";
import type { SessionBoundary } from "@/lib/session-dividers";
import { api } from "@/lib/api";

export function useLeadMessages(leadId: string) {
  return useQuery({
    queryKey: ["messages", leadId],
    queryFn: () =>
      api.get<{ messages: Message[]; sessions: SessionBoundary[] }>(
        `/crm/leads/${leadId}/messages`,
      ),
    enabled: !!leadId,
    // An open conversation has to be live — the team reads incoming WhatsApp
    // here now, and a timeline that only moves on remount is worse than no
    // timeline because it looks current. Safe to poll because the endpoint
    // filters to conversational roles server-side; it used to ship the
    // tool_call / tool_result / options_presented rows too, roughly a quarter
    // of the payload, which would have been re-downloaded every 10s.
    refetchInterval: 10_000,
  });
}
